<script>
import BOForm from '../../baseComponents/boForm'
import { ERROR } from '../../variables'
export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'name', type: 'text', required: true },
				{ label: 'Clef', value: 'key', type: 'text', required: true, disabled: true },
				{ label: 'Type', value: 'computedVariableType', type: 'select', values: ['navigation', 'user', 'specific:user'], required: false, disabled: true },
				{
					label: 'Groupe',
					value: 'subBot',
					required: false,
					type: 'select',
					values: [],
					itemText: (model) => { return model.name },
					itemValue: '_id',
					disabled: true
				}
			]
		}
	},
	methods: {
		async post() {},
		async put() {
			await this.axios.put('botVariables/' + this.model._id, this.model)
		}
	},
	watch: {
		model() {
			if (this.model._id) {
        this.model.computedVariableType = this.model.bot && this.model.variableType === 'user' ? `specific:user` : this.model.variableType
				this.axios.get('subBots?filter=bot._id:$eq:' + this.model.bot)
					.then(response => {
						this.$set(this.items[3], 'values', response.data.resources)
					})
					.catch((err) => {
						this.$store.dispatch(ERROR, err)
					})
			}
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/botVariables/botVariable.form.vue